






















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class StListItem extends Vue {
    @Prop() icon!: string;
    @Prop() editMode!: boolean;
    @Prop() headerClass!: string;
    @Prop() hasParent!: boolean;

    get headerClasses(){
        let result = this.headerClass;

        if(this.editMode){
            result = ' bg-green-500 text-gray-100';
        }

        return result;
    }

    get nested() {
        return this.$slots.nested;
    }

    get subheader() {
        return this.$slots.subheader;
    }
}
